export const KraynyayaData = [
    {
        title: "дом №10",
        year: '1984',
        floor: "5",
        apartment: "60",
        quantityLC: "62",
        livingArea: "2415,2",
        notLivinigArea: "нет",
        commonProperty: "236,3",
        type: "многоэтажный жилой дом",
        level: "ХВС, ГВС, отопление, канализация, газоснабжение, электроснабжение",
        technicalSupport: "общедомовой прибор учета ХВС",
        contractURL: 'kraynyaya/sofrino_kraynyaya_10_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    },

    {
        title: "дом №12",
        year: '1975',
        floor: "5",
        apartment: "59",
        quantityLC: "59",
        livingArea: "2701,7",
        notLivinigArea: "нет",
        commonProperty: "257,1",
        type: "многоэтажный жилой дом",
        level: "ХВС, ГВС, отопление, канализация, газоснабжение, электроснабжение",
        technicalSupport: "общедомовой прибор учета ХВС",
        contractURL: 'kraynyaya/sofrino_kraynyaya_12_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }

]